import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import styles from './styles.scss'
import ModalCard from './ModalCard'

function DialogPlan(props) {
  const {
    onClose,
    isOpen,
    modalTitle,
    modalHelpText,
    cards,
  } = props

  return (
    <Modal
      appElement={document.body}
      className={styles.root}
      onRequestClose={onClose}
      overlayClassName={styles.overlay}
      isOpen={isOpen}
      shouldCloseOnOverlayClick
      contentLabel="DialogPlan"
    >
      <button
        className={styles.buttonClose}
        onClick={onClose}
      >
        <i className="kgnIcon kgn-icon-close2" />
      </button>
      <hgroup
        className={styles.header}
      >
        <h3 className={styles.subtitle}>{modalTitle}</h3>
        <h2 className={styles.title}>{modalHelpText}</h2>
      </hgroup>
      <div className={styles.cardLayout}>
        {cards.map(card => (
          <div
            className={styles.content}
            key={card.title}
          >
            <h2
              className={styles.headertext}
              dangerouslySetInnerHTML={{
              __html: card.headerText,
              }}
            />
            <ModalCard
              className={styles.card}
              {...card}
              onClose={onClose}
            />
          </div>
        ))}
      </div>
    </Modal>
  )
}

DialogPlan.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
  modalHelpText: PropTypes.string,
  cards: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string,
    title: PropTypes.string.isRequired,
    headerText: PropTypes.string.isRequired,
    rate: PropTypes.number.isRequired,
    interval: PropTypes.string.isRequired,
    optionalSubtext: PropTypes.string,
    redirectButtonText: PropTypes.string.isRequired,
    cardColor: PropTypes.string.isRequired,
    cardSecondaryColor: PropTypes.string.isRequired,
    redirectLink: PropTypes.string,
  })),
}

DialogPlan.defaultProps = {
  isOpen: false,
  modalTitle: 'Great news!',
  modalHelpText: 'Special offers available for you at your address',
  cards: [],
}

export default DialogPlan



// WEBPACK FOOTER //
// ./components/DialogPlan/DialogPlan.js